document.documentElement.classList.remove('no-js');

document.addEventListener('click', e => {
  const btn = e.target.closest('[data-quick-add]');
  if (!btn) return;

  e.preventDefault();
  const id = btn.dataset.variantId;
  if (!id) return;

  const original = btn.textContent;
  btn.disabled = true;
  btn.textContent = '…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify({items:[{id:Number(id), quantity:1}]})
  })
  .then(r => {
    if (!r.ok) throw new Error();
    return r.json();
  })
  .then(() => {
    btn.textContent = '✓';
    setTimeout(() => {
      btn.textContent = original;
      btn.disabled = false;
    }, 900);
  })
  .catch(() => {
    btn.textContent = '!';
    setTimeout(() => {
      btn.textContent = original;
      btn.disabled = false;
    }, 900);
  });
});

document.querySelectorAll('[data-product-root]').forEach(root => {
  const select = root.querySelector('[data-variant-select]');
  const price = root.querySelector('[data-product-price]');
  const compare = root.querySelector('[data-product-compare]');
  const add = root.querySelector('[data-add-to-cart]');
  const addLabel = root.querySelector('[data-add-to-cart-label]');

  const sticky = document.querySelector('[data-sticky-bar]');
  const stickyPrice = sticky ? sticky.querySelector('[data-sticky-price]') : null;
  const stickyButton = sticky ? sticky.querySelector('[data-sticky-buy]') : null;
  const stickyLabel = sticky ? sticky.querySelector('[data-sticky-label]') : null;

  function applyOption(option, updateUrl) {
    if (!option) return;

    const variantId = option.value;
    const priceText = option.dataset.priceText || '';
    const compareText = option.dataset.compareText || '';
    const available = option.dataset.available === 'true';
    const mediaId = option.dataset.mediaId || '';

    if (price) price.textContent = priceText;

    if (compare) {
      if (compareText) {
        compare.hidden = false;
        compare.textContent = compareText;
      } else {
        compare.hidden = true;
        compare.textContent = '';
      }
    }

    if (add) add.disabled = !available;
    if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';

    if (stickyPrice) stickyPrice.textContent = priceText;
    if (stickyButton) stickyButton.disabled = !available;
    if (stickyLabel) stickyLabel.textContent = available ? 'Add to cart' : 'Sold out';

    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    }

    if (mediaId) {
      const media = root.querySelector('[data-media-id="' + mediaId + '"]');
      if (media) {
        media.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  }

  if (select) {
    select.addEventListener('change', () => {
      applyOption(select.options[select.selectedIndex], true);
    });
    applyOption(select.options[select.selectedIndex], false);
  }

  if (sticky && add) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const show = !entry.isIntersecting;
        sticky.classList.toggle('is-active', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, {threshold: .15});

    observer.observe(add);
  }
});

document.addEventListener('click', e => {
  const stickyButton = e.target.closest('[data-sticky-buy]');
  if (!stickyButton) return;

  const form = document.querySelector('[data-product-form]');
  const submit = form ? form.querySelector('[data-add-to-cart]') : null;

  if (submit && !submit.disabled) submit.click();
});

const revealObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, {threshold:.08});

document.querySelectorAll('.fade-up').forEach(el => revealObserver.observe(el));
